/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { BookingCancellationReason } from './bookingCancellationReason';

export type OralExamRunStateResponseBookingCancellationReason = BookingCancellationReason | null;
